const Cookies = require('js-cookie')

export default class Consent {
    constructor() {
        this.gdprSettings = $('#gdpr-settings')
        this.stickyGdpr = $('.gdpr-sticky')
        this.stickyGdprAccept = $('#gdpr-accept')
        this.modalGdprColumn = $('.modal__gdpr__column')
        this.modalGdprSave = $('#gdpr-save')
        this.modalGdprAcceptAll = $('#gdpr-accept-all')
        this.modalGdpr = $('#modal-gdpr')
        this.modalGdprContainer = $('#modal-gdpr-container')
        this.gdprVersion = '20241206' // modifying this will show consent sticky for everyone again

        this.consentTypes = {
            1: { // Required
                analytics_storage: 'denied',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
                ad_storage: 'denied'
            },
            2: { // Statistics
                analytics_storage: 'granted',
                ad_user_data: 'denied',
                ad_personalization: 'denied',
                ad_storage: 'denied'
            },
            3: { // Marketing
                analytics_storage: 'granted',
                ad_user_data: 'granted',
                ad_personalization: 'granted',
                ad_storage: 'granted'
            }
        }
    }

    checkConsent() {
        const gdprConsentAccepted = Cookies.get('gdprConsentAccepted')
        const gdprConsentType = Cookies.get('gdprConsentType')
        const gdprConsentVersion = Cookies.get('gdprConsentVersion')
        const showModal = gdprConsentAccepted == 0 || !gdprConsentAccepted || !gdprConsentType || !gdprConsentVersion || gdprConsentVersion != this.gdprVersion

        if (showModal) {
            this.stickyGdpr.addClass('is-visible')
        } else {
            this.setConsentType(gdprConsentType)
        }
    }

    columnClick(e) {
        const me = $(e.currentTarget)
        me.children('.modal__gdpr__radio[name=gdpr-consent]').prop('checked', true)
    }

    saveConsent() {
        const type = $('input[name=gdpr-consent]:checked').val()
        this.saveConsentCookies(type)
    }

    setConsentType(type) {
        gtag('consent', 'update', this.consentTypes[type])
         if (type == 3) {
            // fbq('consent', 'grant');
         }
    }

    saveConsentCookies(type) {
        Cookies.set('gdprConsentAccepted', '1', {
            expires: 365,
            path: "/"
        })
        Cookies.set('gdprConsentType', type, {
            expires: 365,
            path: "/"
        })
        Cookies.set('gdprConsentVersion', this.gdprVersion, {
            expires: 365,
            path: "/"
        })
        this.stickyGdpr.removeClass('is-visible')
        this.closeModal()
        this.setConsentType(type)
    }

    showModal() {
        const gdprConsentType = Cookies.get('gdprConsentType') || '3'
        this.modalGdpr.find('.modal__gdpr__radio').prop('checked', false)
        this.modalGdpr.find(`.modal__gdpr__radio[value=${gdprConsentType}]`).prop('checked', true)
        this.modalGdpr.addClass('is-open')
        this.modalGdprContainer.addClass('is-open')
        $('body').addClass('no-scroll')
    }

    closeModal() {
        this.modalGdpr.removeClass('is-open')
        this.modalGdprContainer.removeClass('is-open')
        $('body').removeClass('no-scroll')
    }

    init() {
        this.checkConsent()
        this.stickyGdprAccept.on('click', () => this.saveConsentCookies(3))
        this.modalGdprColumn.on('click', (e) => this.columnClick(e))
        this.modalGdprSave.on('click', () => this.saveConsent())
        this.modalGdprAcceptAll.on('click', () => this.saveConsentCookies(3))
        this.gdprSettings?.on('click', () => this.showModal())
    }
}
